import { useEffect, useState } from "react";

import { Grid, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { Button } from "../../../../components/base";
import { UnrealizedSource } from "./UnrealizedSource";
import { api, getPercent } from "../../../../services";
import VacancyImg from "../../../../assets/images/unrealized/vacancy.svg";
import UnconnectedTenantsImg from "../../../../assets/images/unrealized/unconnected-tenants.svg";

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 300,
    fontSize: "1.1rem",
  },
  breakdownCol: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(5),
  },
}));

export const TenancyParameters = ({ setConnectTenantsModal }) => {
  const classes = useStyles();
  const [data, setData] = useState();

  useEffect(() => {
    api
      .get("/praas/v1/unrealized/tenancy-parameters/")
      .then((resp) => setData(resp.data));
  }, []);

  return (
    <Grid
      className={classes.breakdownCol}
      item
      xs={12}
      sm={4}
      style={{ borderRight: `1px solid ${COLORS.darks[2]}` }}
    >
      <Typography className={classes.title}>
        TENANCY PARAMETERS - IMPROVE TRADING
      </Typography>
      {data ? (
        <Grid container id="tenancy-parameters">
          <Grid item xs={12}>
            <UnrealizedSource
              img={UnconnectedTenantsImg}
              imgBorderColor="#E1C9A7"
              perYear={data.unconnected_tenants.per_year}
              per20Y={data.unconnected_tenants.per_20y}
              titleContent={
                <>
                  <Grid container>
                    <Typography variant="h2" style={{ color: COLORS.red }}>
                      {data.unconnected_tenants.count}
                    </Typography>
                    <Typography
                      style={{
                        color: COLORS.red,
                        lineHeight: 2.5,
                        marginLeft: 4,
                      }}
                    >
                      (
                      {getPercent(
                        data.unconnected_tenants.count,
                        data.all_tenants
                      )}
                      %)
                    </Typography>
                  </Grid>
                  <Typography variant="h4" style={{ color: COLORS.red }}>
                    Unconnected Tenants
                  </Typography>
                </>
              }
            />
          </Grid>
          <Grid item xs={12}>
            <UnrealizedSource
              img={VacancyImg}
              imgBorderColor="#E1C9A7"
              perYear={data.vacancy.per_year}
              per20Y={data.vacancy.per_20y}
              titleContent={
                <>
                  <Typography variant="h2" style={{ color: COLORS.red }}>
                    {data.vacancy.rate}%
                  </Typography>
                  <Typography variant="h4" style={{ color: COLORS.red }}>
                    Vacancy Rate
                  </Typography>
                </>
              }
            />
          </Grid>
        </Grid>
      ) : null}
      <Button
        text="CONNECT UNCONNECTED TENANTS"
        next
        onClick={() => setConnectTenantsModal(true)}
      />
    </Grid>
  );
};
